import styled from "styled-components";

const bp = { md: "768px" };

const c = {
  ink: "#171717",
  inkSoft: "#5b5b5b",
  gold: "#c9a227",
  goldDeep: "#b78c1a",
  goldSoft: "rgba(201,162,39,0.12)",
  pinkStrong: "#ef6ca9",
  pinkSoft: "rgba(239,108,169,0.08)",
  border: "rgba(18,18,18,0.08)",
  borderStrong: "rgba(18,18,18,0.12)",
};

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background:
    linear-gradient(rgba(12, 12, 12, 0.58), rgba(12, 12, 12, 0.58)),
    radial-gradient(circle at top, rgba(201, 162, 39, 0.08), transparent 30%);
  display: grid;
  place-items: center;
  padding: 20px;
`;

export const ModalCard = styled.div`
  width: min(820px, 100%);
  max-height: min(88vh, 920px);
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff 0%, #fffdf9 100%);
  border: 1px solid ${c.borderStrong};
  border-radius: 30px;
  box-shadow:
    0 30px 80px rgba(0, 0, 0, 0.22),
    inset 0 0 0 1px rgba(201, 162, 39, 0.05);

  @media (max-width: ${bp.md}) {
    max-height: 92vh;
    border-radius: 22px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 22px 24px 16px;
  border-bottom: 1px solid rgba(18, 18, 18, 0.06);
  background: linear-gradient(
    180deg,
    rgba(255, 250, 244, 0.92),
    rgba(255, 255, 255, 0.96)
  );

  @media (max-width: ${bp.md}) {
    padding: 18px 16px 14px;
  }
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: clamp(32px, 4vw, 48px);
  font-family: "Cormorant Garamond", serif;
  font-weight: 650;
  color: ${c.ink};
  line-height: 0.95;
  @media (max-width: ${bp.md}) {
    font-size: 27px;
  }
`;

export const CloseBtn = styled.button`
  width: 44px;
  height: 44px;
  border: 1px solid rgba(18, 18, 18, 0.06);
  border-radius: 999px;
  background: #fff;
  color: ${c.ink};
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    color: ${c.pinkStrong};
    border-color: rgba(239, 108, 169, 0.22);
  }
`;

export const ModalBody = styled.div`
  padding: 18px 24px 20px;
  overflow-y: auto;
  overflow-x: hidden;
  display: grid;
  gap: 18px;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }

  @media (max-width: ${bp.md}) {
    padding: 16px;
    gap: 14px;
  }
`;

export const CakePreview = styled.div`
  display: grid;
  grid-template-columns: 100px 1fr;
  gap: 16px;
  align-items: center;
  padding: 14px;
  border: 1px solid rgba(201, 162, 39, 0.14);
  border-radius: 22px;
  background: linear-gradient(
    180deg,
    rgba(255, 248, 251, 0.9),
    rgba(255, 255, 255, 1)
  );

  @media (max-width: ${bp.md}) {
    grid-template-columns: 78px 1fr;
    gap: 12px;
    padding: 12px;
    border-radius: 18px;
  }
`;

export const CakeImg = styled.img`
  width: 100px;
  height: 100px;
  object-fit: contain;
  border-radius: 18px;
  background: #fff;
  border: 1px solid rgba(201, 162, 39, 0.14);
  padding: 8px;

  @media (max-width: ${bp.md}) {
    width: 78px;
    height: 78px;
    border-radius: 14px;
  }
`;

export const CakeInfo = styled.div`
  display: grid;
  gap: 4px;
`;

export const CakeName = styled.div`
  font-size: clamp(28px, 3vw, 38px);
  font-family: "Cormorant Garamond", serif;
  font-weight: 650;
  line-height: 0.96;
  color: ${c.ink};

  @media (max-width: ${bp.md}) {
    font-size: 20px;
  }
`;

export const CakeMeta = styled.div`
  font-size: 15px;
  color: #7a664c;
  line-height: 1.4;

  @media (max-width: ${bp.md}) {
    font-size: 13px;
  }
`;

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px 16px;

  @media (max-width: ${bp.md}) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const FieldGroup = styled.div`
  display: grid;
  gap: 7px;
  min-width: 0;
`;

export const FieldGroupWide = styled(FieldGroup)`
  grid-column: 1 / -1;
`;

export const FieldLabel = styled.label`
  font-size: 13px;
  font-weight: 700;
  color: ${c.ink};
  letter-spacing: 0.01em;
`;

export const SelectField = styled.select`
  width: 100%;
  min-height: 50px;
  border: 1px solid rgba(201, 162, 39, 0.2);
  border-radius: 16px;
  background: #fff;
  padding: 0 14px;
  font-size: 15px;
  color: ${c.ink};
  outline: none;

  &:focus {
    border-color: rgba(239, 108, 169, 0.42);
    box-shadow: 0 0 0 4px ${c.pinkSoft};
  }

  @media (max-width: ${bp.md}) {
    min-height: 46px;
    border-radius: 14px;
    font-size: 14px;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 112px;
  border: 1px solid rgba(18, 18, 18, 0.08);
  border-radius: 18px;
  background: #fff;
  padding: 14px 15px;
  font-size: 15px;
  color: ${c.ink};
  resize: vertical;
  outline: none;

  &:focus {
    border-color: rgba(239, 108, 169, 0.42);
    box-shadow: 0 0 0 4px ${c.pinkSoft};
  }

  &::placeholder {
    color: #8f8f8f;
  }

  @media (max-width: ${bp.md}) {
    min-height: 80px;
    font-size: 14px;
    border-radius: 16px;
    padding: 12px 13px;
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const FileUploadRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

export const FileTrigger = styled.label`
  min-width: 132px;
  height: 42px;
  padding: 0 15px;
  border-radius: 13px;
  border: 1px solid rgba(201, 162, 39, 0.24);
  background: linear-gradient(180deg, #fffdf8 0%, #fff7ef 100%);
  color: ${c.ink};
  font-size: 13px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    border-color: rgba(239, 108, 169, 0.24);
    background: rgba(239, 108, 169, 0.04);
  }
`;

export const FileName = styled.span`
  font-size: 13px;
  color: ${c.inkSoft};
`;

export const FileHint = styled.a`
  font-size: 11px;
  color: #eb93bc;
  text-decoration: none;
  font-weight: 700;

  &:hover {
    text-decoration: underline;
  }
`;

export const PriceBox = styled.div`
  padding: 16px 18px;
  border-radius: 20px;
  background: linear-gradient(
    180deg,
    rgba(201, 162, 39, 0.12),
    rgba(201, 162, 39, 0.06)
  );
  border: 1px solid rgba(201, 162, 39, 0.16);
  color: ${c.ink};
  font-size: 14px;
  display: grid;
  gap: 4px;

  strong {
    font-size: 34px;
    line-height: 1;
    color: ${c.pinkStrong};
    font-weight: 800;
    letter-spacing: -0.02em;
  }

  @media (max-width: ${bp.md}) {
    strong {
      font-size: 22px;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px 22px;
  border-top: 1px solid rgba(18, 18, 18, 0.06);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.92),
    rgba(255, 250, 244, 0.96)
  );

  @media (max-width: ${bp.md}) {
    padding: 14px 16px 16px;
    flex-direction: column-reverse;
  }
`;

export const CancelBtn = styled.button`
  height: 48px;
  padding: 0 18px;
  border-radius: 15px;
  border: 1px solid rgba(18, 18, 18, 0.12);
  background: #fff;
  color: ${c.ink};
  font-weight: 600;
  cursor: pointer;

  &:hover {
    border-color: rgba(201, 162, 39, 0.22);
    background: rgba(201, 162, 39, 0.04);
  }
`;

export const ConfirmBtn = styled.button`
  height: 48px;
  padding: 0 20px;
  border-radius: 15px;
  border: 0;
  background: linear-gradient(180deg, ${c.gold} 0%, ${c.goldDeep} 100%);
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 12px 22px rgba(183, 140, 26, 0.18);

  &:hover {
    filter: brightness(1.03);
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    box-shadow: none;
  }
`;
